import axios from 'axios';

axios.defaults.baseURL = '/api/filter-cards';
//axios.defaults.baseURL = 'https://me.americanhealthlaw.org/api/filter-cards';

export default {
    load: function(id, page, topics, contentTypes, practiceGroups, taskForces, businessCategories, startDate, endDate, topicFilters, sortOrder) {
		var contentTypesCombined = contentTypes.join(',');
		var params = {
			page: page,
			topics: topics,
			contentTypes: contentTypesCombined
		};

		if(practiceGroups === 'server')
			params.filterByPracticeGroups = true;
		else if(practiceGroups)
			params.practiceGroups = practiceGroups;

		if(sortOrder) {
			params.sortOrder = sortOrder;
		}

		if (taskForces)
			params.taskForces = taskForces;

		if (businessCategories)
			params.businessCategories = businessCategories;

		if (startDate)
			params.startDate = startDate;

		if (endDate)
			params.endDate = endDate;

		if (topicFilters) {
			params.topicFilters = topicFilters;
		}
	

		return axios
				.get(`${id}`, {
						params: params
				});
    }
}